import { Link } from 'react-router-dom';
import { getAssetUrl } from '../../utils/assetUrl';
import { TranslationKeyEnum } from '../../types/constants';
import { useTranslation } from '../../hooks/useTranslation';

export function PageNotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
      <img
        src={getAssetUrl('images/cat_dog.svg')}
        alt={t(TranslationKeyEnum.PageNotFoundAlt)}
        className="max-w-md w-full h-auto mb-2"
      />
      <p className="text-2xl text-gray-600 mt-2">{t(TranslationKeyEnum.PageNotFoundMessage)}</p>
      <Link
        to="/"
        className="mt-6 px-6 py-2 bg-primary text-white rounded hover:bg-blue-900 transition-colors"
      >
        {t(TranslationKeyEnum.GoBackHome)}
      </Link>
    </div>
  );
}
